function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import DefaultProps from "./default-props";
import RegularButton from "../regular-button/regular-button";
import { trackEvent } from "services/bigbrain-service";
import { DOWNLOAD_APP_BUTTON_CLICKED, DOWNLOAD_APP_BUTTON_NO_LINK_FOUND } from "constants/bigbrain-event-types";
import { GenericConfigContext } from "contexts/generic-config-context";
import { useContext } from "react";
import classnames from "classnames";
const getAppsflyerUrl = ()=>{
    var _window_AF_SMART_SCRIPT_RESULT, _window;
    const url = ((_window = window) === null || _window === void 0 ? void 0 : (_window_AF_SMART_SCRIPT_RESULT = _window.AF_SMART_SCRIPT_RESULT) === null || _window_AF_SMART_SCRIPT_RESULT === void 0 ? void 0 : _window_AF_SMART_SCRIPT_RESULT.clickURL) || "";
    if (!url) {
        trackEvent(DOWNLOAD_APP_BUTTON_NO_LINK_FOUND);
    }
    return url;
};
const DownloadAppButton = (props)=>{
    const { isMobileOrTabletBrowser } = useContext(GenericConfigContext);
    const handleDefaultURL = ()=>{
        if (isMobileOrTabletBrowser) {
            window.open(props.defaultMobileURL, '_self');
        } else {
            window.open(props.defaultDesktopURL, '_self');
        }
    };
    const handleClick = ()=>{
        const appsflyerUrl = getAppsflyerUrl();
        const eventKind = isMobileOrTabletBrowser ? "mobile" : "desktop";
        if (appsflyerUrl) {
            trackEvent(DOWNLOAD_APP_BUTTON_CLICKED, {
                kind: eventKind,
                info1: appsflyerUrl
            });
            window.open(appsflyerUrl, '_self');
        } else {
            trackEvent(DOWNLOAD_APP_BUTTON_CLICKED, {
                kind: eventKind,
                info1: isMobileOrTabletBrowser ? props.defaultMobileURL : props.defaultDesktopURL
            });
            handleDefaultURL();
        }
    };
    return /*#__PURE__*/ _jsx(RegularButton, _object_spread_props(_object_spread({}, props), {
        onClick: handleClick,
        className: classnames(props.className, "af-smart-button")
    }));
};
DownloadAppButton.defaultProps = DefaultProps;
export default DownloadAppButton;
